// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_R8F","cls2":"ResearchInterestTags-cls2_ry6 ResearchInterestTags-cls1_R8F"};